import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { ITaskListItem, TaskListItem } from "./taskListItem";

export interface ITaskListItems extends ListItems<ITaskListItem> {
}

export class TaskListItems extends ListItems<TaskListItem> implements ITaskListItems {
    constructor();
    constructor(obj: ITaskListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, TaskListItem);
    }
}